﻿import React from 'react';
import { useTranslation } from 'react-i18next';
import Navigation_Item from '@Elements/SideNavigation/Navigation_Item';
import {
    Icon_Dashboard,
    Icon_Customers,
    Icon_Assignments,
    Icon_Analytics,
    Icon_Reminders
} from '@Elements/ImageElements/Icons';
import { dashboard_pages } from '@Util/GlobalValues';

export default function Navigation(): JSX.Element {
    const [t] = useTranslation();

    return (
        <nav>
            <ul className="Side_Navigation_List">
                <Navigation_Item
                    key="Navigation_Home"
                    to={dashboard_pages.home}
                    name={t("Navigation.Home")}
                    icon={<Icon_Dashboard />}
                    adminRequired={false}
                />
                <Navigation_Item
                    key="Navigation_Customers"
                    to={dashboard_pages.customers}
                    name={t("Navigation.Customers")}
                    icon={<Icon_Customers />}
                    adminRequired={false}
                />
                <Navigation_Item
                    key="Navigation_Projects"
                    to={dashboard_pages.projects}
                    name={t("Navigation.Projects")}
                    icon={<Icon_Assignments />}
                    adminRequired={false}
                />
                <Navigation_Item
                    key="Navigation_Reminders"
                    to={dashboard_pages.reminders}
                    name={t("Navigation.Reminders")}
                    icon={<Icon_Reminders />}
                    adminRequired={false}
                />
                <Navigation_Item
                    key="Navigation_Report"
                    to={dashboard_pages.report}
                    name={t("Navigation.Report")}
                    icon={<Icon_Analytics />}
                    adminRequired={true}
                />
            </ul>
            <ul className="Side_Navigation_List">
                <Navigation_Item
                    key="Navigation_Customer_Websites"
                    to={dashboard_pages.customer_websites}
                    name={t("Navigation.CustomerWebsites")}
                    icon={
                        <img
                            src="/InTime/Templates/Images/dx-logo-95x95.png"
                            alt="Dynamix logo"
                            loading="eager"
                            style={{ aspectRatio: "1/1" }}
                        />
                    }
                    adminRequired={false}
                />
            </ul>
        </nav>
    );
}